<template>
    <v-container>
        <!-- dialog -->
        <v-dialog
            v-model="dialog"
            width="350"
        >
            <v-card class="rounded-BigLg">
                <v-card-title class="text-h5 pb-0 pt-1 px-2" >
                    <v-btn small icon @click="dialog = false">
                        <v-icon color="grey" small> mdi-close </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-center ">
                    <v-icon color="primary" class="my-1"> mdi-logout </v-icon>
                    <h3 class="my-1"> إنهاء رحلة </h3>
                    هل أنت متأكد أنك تريد إنهاء الرحلة ؟
                </v-card-text>

                <v-card-actions class="d-flex justify-center">
                    <div>
                        <v-btn @click="endTripToSchool()" small color="primary" :loading="submitLoading" class="me-2">
                            موافق
                        </v-btn>

                        <v-btn small text @click="dialog = false" :disabled="submitLoading">
                            إلغاء
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- dialogMessage -->
        <v-dialog v-model="dialogMessage" width="350">
            <v-card>
                <v-card-title class="d-flex justify-space-between pb-0">
                    <span>
                        الرسائل
                    </span>
                    <v-btn icon :disabled="loading || submitLoading" color="primary" @click="dialogMessage = false">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-1 px-2">
                        <v-col cols="12" align-self="center" class="pa-1">
                            <v-autocomplete
                                v-model="studentIds"
                                :items="filteredStudents.filter(c => c.StudentInBusStatus !== studentInBusStatus.notInBus)"
                                :item-text="(item) => `${item.FirstName} ${item.LastName}`"
                                item-value="AccountId"
                                outlined
                                dense
                                label="اسم الطالب"
                                hide-details
                                class="rounded-BigLg"
                                :disabled="loading"
                                multiple
                                clearable
                                autofocus
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggle"
                                    >
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ iconCities }}
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.FirstName }} {{ item.LastName }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ studentIds.length - 1 }})
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" align-self="center" class="pa-1">
                            <!-- messages -->
                            <v-autocomplete
                                v-model="message"
                                :items="messages"
                                item-text="Message"
                                item-value="ID"
                                outlined
                                dense
                                label="الرسالة"
                                hide-details
                                class="rounded-BigLg"
                                height="100"
                                :loading="loading"
                                clearable
                                :disabled="loading"
                            />
                        </v-col>

                        <v-col cols="12" class="py-1">
                            <v-btn
                                color="primary"
                                class="rounded-BigLg"
                                width="100%"
                                :disabled="loading || !studentIds.length || !message"
                                @click="sendMessage()"
                            >
                                إرسال
                                <v-icon size="10" class="mx-1"> mdi-send </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <template v-if="!showScanner">
            <v-row class="mx-1">
                <v-col cols="6" align-self="center" class="pb-0">
                    <p class="mb-1"> {{ info.DriverName || '-' }} </p>
                    <p class="mb-1"> {{ info.DriverPhone || '-' }} </p>
                </v-col>
                <v-col cols="6" align-self="center" class="pb-0">
                    <p dir="ltr" class="mb-1 text-end primary--text"> {{ moment().format('hh:mm a') || '-' }} </p>
                    <p class="mb-1"> رقم الباص: {{ info.BusNo || '-' }} </p>
                </v-col>
            </v-row>

            <v-row class="d-flex mt-0 justify-space-around mb-1">
                <v-col cols="5" class=" px-0 me-3 pb-1">
                    <v-btn
                        class="rounded-BigLg"
                        width="100%"
                        color="secondary"
                        @click="
                            isStartTrip === true
                                ? dialog = true
                                : endTrip()"
                    >
                        {{ isStartTrip === true ? 'الوصول إلى المدرسة' : 'إنهاء رحلة' }}
                    </v-btn>
                </v-col>

                <v-col v-if="0" cols="5" class="px-0 me-3 pb-1">
                    <v-btn class="rounded-BigLg" width="100%" color="secondary" @click="showScanner = true">
                        مسح رمز QR
                    </v-btn>
                </v-col>

                <v-col cols="5" class="px-0 me-3 pb-1">
                    <v-btn class="rounded-BigLg" width="100%" color="secondary" @click="dialogMessage = true">
                        إرسال رسالة
                    </v-btn>
                </v-col>
            </v-row>

            <span class="px-4"> الطلاب ({{ studentFilterByTripType?.length || 0 }} {{ studentFilterByTripType?.length > 10 ? 'طالب' : 'طلاب' }}) </span>

            <!-- cards -->
            <v-card elevation="0">
                <v-row  class="scroll-style mt-1 d-flex justify-start">
                    <v-col v-for="(student, index) in studentFilterByTripType" :key="index" cols="12" md="6" class="py-0" align-self="center">
                        <!-- cards -->
                        <v-card
                            elevation="2"
                            class="rounded-BigLg px-1 mx-2 d-flex justify-center align-center my-2"
                            style="height: 60px"
                            :class="{
                                'border-red': student.StudentInBusStatus === studentInBusStatus.notInBus,
                                'border-green': student.StudentInBusStatus === studentInBusStatus.newBus
                            }"
                        >
                            <v-row class="px-2" >
                                <v-col cols="3" class="py-1 px-1 h-100" align-self="center">
                                    <span class="fs-sm"> {{ student.FirstName || '-' }} {{ student.LastName || '-' }} </span>
                                </v-col>

                                <v-divider vertical class="my-4 px-1" />

                                <v-col class="py-1 px-1 h-100" cols="3" align-self="center">
                                    <div class="fs-sm">
                                        <span class="primary--text"> {{ isStartTrip === true ? 'وقت الوصول' : 'وقت العودة' }}   </span>
                                        <br />
                                        <span dir="ltr"> {{ isStartTrip === true ? moment(student.ArrivalTime).format('hh:mm a') :  moment(student.ReturnTime).format('hh:mm a') }} </span>
                                    </div>
                                </v-col>
                                <v-col class="py-1 px-1 h-100" cols="3" align-self="center">
                                    <div class="fs-sm">
                                        <span class="primary--text"> رقم الموبايل </span>
                                        <div class="d-flex flex-column">
                                            {{
                                                student.FatherPhoneNumber || '-'
                                            }}
                                            <br />
                                            {{
                                                student.MotherPHoneNUmber || '-'
                                            }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-spacer />

                                <v-col v-if="!student.inHome && !student.studentStatus && student.studentStatus !== false && (getStudent === null || !getStudent.find(s => s.accountId === student.AccountId))"
                                    cols="2"
                                    class="d-flex justify-end px-0"
                                >
                                    <v-btn
                                        class="rounded-btn-card"
                                        width="100%"
                                        :height="student.StudentInBusStatus === studentInBusStatus.notInBus || student.StudentInBusStatus === studentInBusStatus.newBus ? '56' : '59' "
                                        color="primary"
                                        @click="sheet = true; studentInfo = student"
                                        :disabled="student.StudentInBusStatus === studentInBusStatus.notInBus"
                                    >
                                        <span v-if="isStartTrip === true">
                                            <div>
                                                <span v-if="student.StudentInBusStatus !== studentInBusStatus.notInBus">
                                                    الحالة
                                                </span>
                                                <span v-else>
                                                    منقول
                                                </span>
                                            </div>
                                        </span>

                                        <div v-else>
                                            <span v-if="student.StudentInBusStatus !== studentInBusStatus.notInBus">
                                                في
                                                <br />
                                                الباص
                                            </span>
                                            <span v-else>
                                                منقول / غائب
                                            </span>
                                        </div>
                                    </v-btn>
                                </v-col>

                                <v-col v-if=" isStartTrip === false && (student.inHome === true || Boolean(getStudent !== null && getStudent.find(s => s.accountId == student.AccountId)))"
                                    cols="2"
                                    class="d-flex px-0"
                                >
                                    <v-btn
                                        class="rounded-btn-card"
                                        width="100%"
                                        :height="student.StudentInBusStatus === studentInBusStatus.notInBus || student.StudentInBusStatus === studentInBusStatus.newBus ? '56' : '59'"
                                        color="success"
                                        readonly
                                    >
                                        في المنزل
                                    </v-btn>
                                </v-col>

                                <v-col
                                    v-if="
                                        (student.studentStatus === true || student.studentStatus === false) ||
                                        (getStudent !== null && (
                                            getStudent.find(s => s.accountId === student.AccountId)?.status === true
                                            || getStudent.find(s => s.accountId === student.AccountId)?.status === false
                                        ))
                                    "
                                    cols="2"
                                    class="d-flex justify-end px-0"
                                >
                                    <v-btn
                                        class="rounded-btn-card"
                                        width="100%"
                                        :height="
                                            student.StudentInBusStatus === studentInBusStatus.notInBus ||
                                            student.StudentInBusStatus === studentInBusStatus.newBus ? '56' : '59'"
                                        readonly
                                        :color="student.studentStatus === true || (getStudent !== null && getStudent.find(s => s.accountId === student.AccountId)?.status  === true) ? 'green white--text' : 'red white--text'"
                                    >
                                        {{ student.studentStatus === true || (getStudent !== null && getStudent.find(s => s.accountId === student.AccountId)?.status  === true) ? 'موجود' : 'غائب' }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>

            <v-bottom-sheet
                v-model="sheet"
            >
                <v-sheet
                    class="text-center"
                    height="230px"
                >
                    <v-row class="px-5">
                        <v-col cols="8">
                            <h3 class="text-start">
                                {{ studentInfo.FirstName || '-' }} {{ studentInfo.LastName || '-' }}
                            </h3>
                            <div class="text-start">
                                <v-icon color="primary"> mdi-map-marker </v-icon>
                                <span> {{ (studentInfo.Area || '-' ) + ' - ' + (studentInfo.Address) }} </span>
                            </div>
                        </v-col>

                        <v-col cols="4" class="d-flex flex-column px-1">
                            <v-btn color="success" class="rounded-xl" width="100%" @click="call(studentInfo.FatherPhoneNumber)">
                                <v-icon class="pe-2"> mdi-phone </v-icon>
                                اتصال بالأب
                            </v-btn>

                            <v-btn color="success" class="rounded-xl mt-2" @click="call(studentInfo.MotherPHoneNUmber)">
                                <v-icon class="pe-2"> mdi-phone </v-icon>
                                اتصال بالأم
                            </v-btn>
                        </v-col>

                        <v-col v-if="isStartTrip === true" cols="12">
                            <div>
                                <v-btn
                                    width="48%"
                                    class="rounded-BigLg me-1"
                                    color="success white--text"
                                    @click="studentInfo.studentStatus = true; studentAttend(studentInfo)"
                                    :loading="submitLoading && studentInfo.studentStatus"
                                    :disabled="(submitLoading && !studentInfo.studentStatus) || nearHomeLoading"
                                >
                                    تسجيل حضور
                                </v-btn>
                                <v-btn
                                    width="48%"
                                    class="rounded-BigLg ms-1"
                                    color="red white--text"
                                    @click="studentInfo.studentStatus = false; studentAttend(studentInfo)"
                                    :loading="submitLoading && !studentInfo.studentStatus"
                                    :disabled="(submitLoading && studentInfo.studentStatus) || nearHomeLoading"
                                >
                                    تسجيل غياب
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col v-else cols="12">
                            <v-btn
                                v-if="!studentInfo.inHome"
                                width="100%"
                                class="rounded-BigLg me-1"
                                color="success white--text"
                                @click="studentInfo.inHome = true; endTripToHome(studentInfo)"
                                :disabled="nearHomeLoading"
                                :loading="submitLoading"
                            > وصول إلى المنزل </v-btn>
                        </v-col>
                        <v-col cols="12" class="">
                            <v-btn
                                color="secondary"
                                width="100%"
                                :loading="nearHomeLoading"
                                class="rounded-BigLg"
                                @click="nearHome(studentInfo)"
                            >
                                قريب جداً!
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-bottom-sheet>
        </template>
        <!-- Scanner view -->
        <!-- <div v-if="showScanner" class="scanner-container">
            <v-btn
                class="close-scanner-btn"
                icon
                @click="closeScanner"
            >
                <v-icon color="white">mdi-close</v-icon>
            </v-btn>
            <StreamBarcodeReader
                @decode="onDecode"
                @loaded="onLoaded"
            ></StreamBarcodeReader>
            <div class="scanner-overlay">
                <div class="scanner-line"></div>
            </div>
        </div> -->
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { studentInBusStatus, tripType } from '@/helper/enums'
// import { StreamBarcodeReader } from 'vue-barcode-reader'
export default {
    components: {
        // StreamBarcodeReader
        // ImageBarcodeReader
    },

    data () {
        return {
			sheet: false,
			studentInfo: {},
            dialog: false,
            isStart: true,
            submitLoading: false,
            studentStatus: null,
            decodedText: '',
            showScanner: false,
            isExist: true,
            studentData: [],
            students: [], // Local state for students
            nearHomeLoading: false,
            permission: null,
            dialogMessage: false,
            studentIds: [],
            message: null,
            loading: false,
            all: null,
            vueStudentStore: [],
            studentInBusStatus,
            tripType,
            latitude: null,
            longitude: null
        }
    },

    watch: {
        dialogMessage (val) {
            if (!val) {
                this.studentIds = []
                this.message = null
            }
        }
    },

    computed: {
        ...mapState({
            info: state => state.auth.info,
            centerId: state => state.auth.centerId,
            messages: state => state.messages.messages,
            studentss: state => state.auth.info.students,
            busId: state => state.auth.info?.busId || null
        }),

        isStartTrip () {
            return JSON.parse(this.$route.query.isStart)
        },

        getStudent () {
            return JSON.parse(localStorage.getItem('studentsLocal'))
        },

        studentFilterByTripType () {
            let students = this.studentss
            if (this.isStartTrip === true) {
                console.log('true')
                students = this.studentss?.filter(c => c.TripType === tripType.roundTrip || c.TripType === tripType.oneWay)
            } else if (this.isStartTrip === false) {
                console.log('false')
                students = this.studentss?.filter(c => c.TripType === tripType.roundTrip || c.TripType === tripType.returnOnly)
            }
            return students
        },

        filteredStudents () {
            // const vueStudentStore = JSON.parse(this.vueStudentStore)
            // const studentsLocal = JSON.parse(localStorage.getItem('studentsLocal')) || []
            // if (!this.info.students) return []
            // if (studentsLocal.length === 0) return this.info.students

            // const attendedStudentIds = studentsLocal.map(s => s.accountId)
            // return this.info.students.filter(student => !attendedStudentIds.includes(student.AccountId))
            console.log('localstore', this.vueStudentStore)
            const studentsLocal = this.vueStudentStore || []
            if (!this.studentFilterByTripType) return []
            if (studentsLocal.length === 0) return this.studentFilterByTripType

            const attendedStudentIds = this.vueStudentStore.map(s => s.accountId)
            return this.studentFilterByTripType.filter(student => !attendedStudentIds.includes(student.AccountId))
        },
        selectedAll () {
            return this.studentIds.length === this.filteredStudents.length
        },
        iconCities () {
            if (this.selectedAll) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        }
    },

    methods: {
        moment,
        studentAttend (studentInfo) {
            this.submitLoading = true
            this.$store.dispatch('transport/studentAttend', {
                centerId: this.info.CenterId,
                userName: localStorage.getItem('userName'),
                accountId: studentInfo.AccountId,
                status: studentInfo.studentStatus,
                fromSchool: Boolean(!this.$route.query.isStart)
            }).then(() => {
                // Update local student status
                const studentIndex = this.students.findIndex(s => s.AccountId === studentInfo.AccountId)
                if (studentIndex !== -1) {
                    this.students[studentIndex].status = status
                }

                // Update studentsLocal in localStorage
                const studentsLocal = JSON.parse(localStorage.getItem('studentsLocal'))
                const localStudentIndex = studentsLocal.findIndex(s => s.accountId === studentInfo.AccountId)
                const isPresent = studentInfo.studentStatus

                if (localStudentIndex > -1) {
                    studentsLocal[localStudentIndex].status = isPresent
                } else {
                    studentsLocal.push({ accountId: studentInfo.AccountId, status: isPresent })
                }
                localStorage.setItem('studentsLocal', JSON.stringify(studentsLocal))
                localStorage.getItem('studentsLocal')
                this.vueStudentStore.push(JSON.stringify(studentsLocal))
                console.log('vueStudentStore', this.vueStudentStore)
                this.$router.go(0)
                this.submitLoading = false
                this.sheet = false
                this.$eventBus.$emit('تم تسجيل الحالة بنجاح')
                studentInfo.isExist = studentInfo.studentStatus
            }).catch(() => {
                this.submitLoading = false
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
                // this.studentStatus = false
            })
        },

        call (number) {
            if (number) {
                window.location.href = `tel:${number}`
            }
        },

        // onDecode (result) {
        //     if (result) {
        //         const student = this.info.students.find(s => s.AccountId === result)
        //         if (student) {
        //             this.studentInfo = student
        //             this.sheet = true
        //             this.closeScanner()
        //             this.$eventBus.$emit('تم العثور على الطالب')
        //         } else {
        //             this.$eventBus.$emit('الطالب غير موجود في هذه الرحلة')
        //         }
        //     }
        // },

        // onLoaded () {
        //     console.log('Barcode reader loaded')
        // },

		// closeScanner () {
		// 	this.showScanner = false
		// },

		// openScanner () {
		// 	this.showScanner = true
		// },

        endTripToSchool () {
            this.submitLoading = true
            this.$store.dispatch('transport/endTrip', {
                centerId: this.info.CenterId,
                userName: localStorage.getItem('userName'),
                accountIds: this.info.students.map(s => s.studentStatus !== false ? s.AccountId : null).filter(Boolean)
            }).then(() => {
                this.$eventBus.$emit('تم إنهاء الرحلة بنجاح')
                this.dialog = false
                this.$router.replace({ name: 'choose-page' })
                localStorage.setItem('studentsLocal', JSON.stringify([]))
                this.info.students.forEach(student => {
                    student.isExist = null
                    student.studentStatus = null
                })
            }).catch(() => {
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
            })
        },

        endTripToHome (studentInfo) {
            this.submitLoading = true
            this.$store.dispatch('transport/endTripToHome', {
                centerId: this.info.CenterId,
                userName: localStorage.getItem('userName'),
                accountId: studentInfo.AccountId
            }).then(() => {
                studentInfo.inHome = true
                this.sheet = false
                this.$eventBus.$emit('تم إنهاء رحلة العودة بنجاح')
                this.studentData.push({
                    isExist: studentInfo.studentStatus,
                    AccountId: studentInfo.AccountId,
                    inHome: studentInfo.inHome
                })
                this.studentData = []
                // Update studentsLocal in localStorage
                const studentsLocal = JSON.parse(localStorage.getItem('studentsLocal'))

                studentsLocal.push({ accountId: studentInfo.AccountId })
                localStorage.setItem('studentsLocal', JSON.stringify(studentsLocal))
                localStorage.getItem('studentsLocal')
                // console.log('test')
                this.$router.go(0)
            }).catch(() => {
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
            })
        },

        resetLocal () {
            localStorage.setItem('studentsLocal', JSON.stringify([]))
        },

        nearHome (studentInfo) {
            this.nearHomeLoading = true
            this.$store.dispatch('transport/updateNearHome', {
                centerId: this.info.CenterId,
                userName: localStorage.getItem('userName'),
                accountId: studentInfo.AccountId
            }).then(() => {
                this.nearHomeLoading = false
                this.sheet = false
            }).finally(() => {
                this.nearHomeLoading = false
            })
        },
        sendNotification () {
            const notification = new Notification('عنوان الإشعار', {
                body: 'هذا هو محتوى الإشعار!',
                icon: 'https://example.com/icon.png' // يمكنك وضع رابط أي أيقونة هنا
            })

            notification.onclick = () => {
                window.focus()
            }
        },

        sendMessage () {
            this.loading = true
            this.$store.dispatch('messages/sendMessage', {
                centerId: localStorage.getItem('centerId'),
                userName: localStorage.getItem('userName'),
                AccountIds: this.studentIds,
                QuickMessageId: this.message
            }).then(() => {
                this.studentIds = []
                this.message = null
                this.$eventBus.$emit('show-snackbar', 'تم إرسال الرسالة بنجاح')
                this.dialogMessage = false
            }).catch(() => {
                this.$eventBus.$emit('show-snackbar', 'فشل إرسال الرسالة')
            }).finally(() => {
                this.loading = false
            })
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAll) {
                    this.studentIds = []
                } else {
                    this.studentIds = this.filteredStudents.map(c => c.id)
                    this.setStudent()
                }
            })
        },

        setStudent () {
            this.studentIds = []
            if (!this.filteredStudents) return
            this.filteredStudents.forEach(student => {
                this.studentIds.push(student.AccountId)
            })
        },

        endTrip () {
            this.$router.replace({ name: 'choose-page' })
            this.info.students.forEach(student => { student.inHome = null })
            this.studentData = []
            localStorage.removeItem('studentsLocal')
            this.resetLocal()
        },

        getLocation () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.latitude = position.coords.latitude
                        this.longitude = position.coords.longitude
                        console.log(this.latitude)
                        console.log(this.longitude)

                        this.$store.dispatch('transport/sendBusCoordinates', {
                            centerId: this.info.CenterId,
                            userName: localStorage.getItem('userName'),
                            busId: this.busId,
                            lng: String(this.longitude),
                            lat: String(this.latitude)
                        })
                    },
                    (error) => {
                        console.error('خطأ في الحصول على الموقع:', error)
                    }
                )
            } else {
                alert('جهازك لا يدعم تحديد الموقع.')
            }
        },

        startInterval () {
            this.interval = setInterval(() => {
                this.getLocation()
            }, 30000)
        }
    },

    mounted () {
        this.startInterval()
    },

    created () {
        if (!this.messages.length) {
            this.loading = true
            // console.log(this.info.AssistantName)
            this.$store.dispatch('messages/fetchAll', {
                centerId: localStorage.getItem('centerId'),
                userName: localStorage.getItem('userName')
            }).finally(() => {
                this.loading = false
            })
        }
        // Initialize studentsLocal in localStorage if it doesn't exist
        if (!localStorage.getItem('studentsLocal')) {
            localStorage.setItem('studentsLocal', JSON.stringify([]))
        } else {
            this.vueStudentStore = JSON.parse(localStorage.getItem('studentsLocal')) || []
        }

        if (localStorage.getItem('auth')) {
            const authData = JSON.parse(localStorage.getItem('auth'))
            let studentsData = authData.Student || []
            const studentsLocal = JSON.parse(localStorage.getItem('studentsLocal'))

            if (studentsData.length > 0 && studentsLocal && studentsLocal.length > 0) {
                studentsData = studentsData.map(student => {
                    const localStudent = studentsLocal.find(s => s.accountId === student.AccountId)
                    if (localStudent) {
                        // Assuming status 1 for present, 2 for absent
                        return { ...student, status: localStudent.status }
                    }
                    // if no local status, default to absent (or another default)
                    return { ...student, status: student.status || false }
                })
            }
            this.students = studentsData
        }

        this.permission = Notification.permission
        console.log('this.vueStudentStore', this.vueStudentStore)
    }
}
</script>

<style>
.rounded-btn-card {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
}

.border-red {
    border: 2px solid red !important;
    border-radius: 12px;
}
.border-green {
    border: 2px solid green !important;
    border-radius: 12px;
}
/* .scroll-style {
    float:left;
    overflow-y: auto;
    height: 800px;
} */
/* .scanner-container {
    width: 100%;
    height: 100vh;
    scroll-behavior: auto;
    direction: ltr;
} */
/*
.scanner-container div {
    width: 100%;
    height: 100vh;
    direction: ltr;
    width: 100%;
} */
/* .scanner-container >>> video {
    width: 100%;
    height: 100%;
    direction: ltr;
    width: 100%;
} */

</style>
